import React from "react";


function HeaderSection() {
	const rootElement = document.getElementById("root");
	const landingElement = document.getElementById("landing");

	function goBack() {
		landingElement.style.display = "block";
		rootElement.style.display = "none";

		document.location.reload();
		
	}

	return (
		<header className="flex-shrink-0">
			<nav className="navbar navbar-expand-lg navbar-light bg-white py-2">
				<div className="container px-2">
					<span className="navbar-brand">
						<img
							src="assets/ecoassist_novamarca22_positiva.svg"
							className="fw-bolder text-primary"
							alt="ecoassit"
						/>
					</span>
					<button
						className="navbar-toggler"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent"
						aria-controls="navbarSupportedContent"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon"></span>
					</button>
					<div className="collapse navbar-collapse" id="navbarSupportedContent">
						<ul className="navbar-nav ms-auto mb-2 mb-lg-0 small fw-bolder">
							<li className="nav-item">
								<span
									style={{ cursor: "pointer" }}
									className="nav-link underline-with-space"
									onClick={goBack}
								>
									Voltar ao início
								</span>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</header>
	);
}

export default HeaderSection;
